<svg
    class="gable"
    viewBox="0 0 48 40"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true">
    <!-- house body -->
    <path
        class="body"
        d="M48 35.8647V22.1253C48 20.9314 47.5009 19.7958 46.631 19.0105L26.7029 1.02041C25.1996 -0.336693 22.9587 -0.340553 21.451 1.01137L1.37912 19.0097C0.503193 19.7952 0 20.9349 0 22.1336L0 35.8044C0 38.0859 1.78731 39.9364 3.99417 39.9397L43.9942 40C46.2056 40.0033 48 38.1509 48 35.8647Z"/>

    <!-- left eye. No tiny highlight circle — at chat render sizes (24px)
         the r=0.55 dot anti-aliases into a crosshair / 4-point shape that
         reads as "+ eyes". Pupil alone is a clean dot. -->
    <g class="eye left-eye">
        <circle cx="15" cy="22" r="6.5" fill="white" stroke="#1B1E23" stroke-width="1"/>
        <circle cx="15" cy="22" r="1.9" fill="#1B1E23"/>
    </g>

    <!-- right eye -->
    <g class="eye right-eye">
        <circle cx="33" cy="22" r="6.5" fill="white" stroke="#1B1E23" stroke-width="1"/>
        <circle cx="33" cy="22" r="1.9" fill="#1B1E23"/>
    </g>

    <!-- smile -->
    <path
        d="M22.3 21 Q24 22.3 25.7 21"
        stroke="#1B1E23"
        stroke-width="0.7"
        fill="none"
        stroke-linecap="round"/>

    <!-- Thought bubble cluster — classic "..o O" trail going up-and-right.
         Smallest closest to his head, biggest farthest away. Visible when
         the host has .is-thinking. -->
    <g class="thought-bubble" aria-hidden="true">
        <circle class="bubble bubble-1" cx="38" cy="5" r="2" fill="#C1DDFC" stroke="#1B1E23" stroke-width="0.5"/>
        <circle class="bubble bubble-2" cx="45" cy="-1" r="3.5" fill="#C1DDFC" stroke="#1B1E23" stroke-width="0.6"/>
        <circle class="bubble bubble-3" cx="58" cy="-13" r="10" fill="#C1DDFC" stroke="#1B1E23" stroke-width="0.7"/>
    </g>
</svg>
